import AddressInputSdk from '../components/AddressInput/corvid/AddressInput.corvid';


const AddressInput = {
  sdk: AddressInputSdk
};


export const components = {
  ['AddressInput']: AddressInput
};

